import React, {useEffect} from 'react';
import {Flex, Spinner, Text} from '@chakra-ui/react';
import {ValidateFileProps, validateFile} from '../../lib/validateFile';

export const FileValidator = <T extends object>({
  maxRows,
  onFileValidate,
  selectedFile,
  rowSchemaTypeguard,
}: ValidateFileProps<T>) => {
  useEffect(() => {
    validateFile({maxRows, onFileValidate, rowSchemaTypeguard, selectedFile});
  }, [selectedFile, maxRows, onFileValidate, rowSchemaTypeguard]);

  return (
    <Flex
      direction="row"
      alignItems="center"
      justifyContent="center"
      w="100%"
      gap="4"
      h="60"
    >
      <Spinner />
      <Text>
        Checking <em>{selectedFile?.name}</em>.
      </Text>
    </Flex>
  );
};
